import { HTMLAttributes } from 'react';
import classNames from 'classnames';
import './Screen.scss';

export interface ScreenProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

/**
 * Screen component
 *
 * This component utilizes a breakpoint template to define the sizes of breakpoints and margins applied on each page.
 * The goal is to standardize the breakpoints and margins across all pages.
 * @param children - The content of the screen component.
 * @param className - Additional classes to apply to the screen component.
 */
export const Screen: React.FC<ScreenProps> = ({ children, className, ...rest }) => {
  return (
    <div className={classNames('vds-screen', className)} {...rest}>
      {children}
    </div>
  );
};
